import React from "react";

/**
 * Scroll-to-bottom FAB button.
 * @param {object} props
 * @param {boolean} props.visible - Whether FAB should be visible
 * @param {function} props.onClick - Click handler
 */
export default function ChatScrollFab({ visible, onClick }) {
  if (!visible) return null;

  return (
    <button
      type="button"
      className="scroll-bottom-fab"
      onClick={onClick}
      aria-label="Прокрутить вниз"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </button>
  );
}
